import React, { useState } from 'react';
import CalcShell, { PrintHeaderButton } from '../CalcShell';
import { Heart, Play, User } from 'lucide-react';

export default function LoveCalc() {
  const [n1, setN1] = useState('Saurabh');
  const [n2, setN2] = useState('Damini');
  const [pct, setPct] = useState(null);

  const calc = () => {
    if (!n1 || !n2) return;
    const combined = (n1 + n2).toLowerCase();
    let hash = 0;
    for (let i = 0; i < combined.length; i++) hash = (hash * 31 + combined.charCodeAt(i)) & 0xffff;
    const p = 40 + (hash % 61);
    setPct(p);
  };
  const message = pct >= 90 ? 'Perfect Match' : pct >= 75 ? 'Great Match' : pct >= 50 ? 'Good Match' : pct >= 30 ? 'Room to grow' : 'Better as friends';
  const line = pct >= 90 ? 'Your love burns as hot as the sun, blazing through the vastness of space, and searing itself into your being.'
    : pct >= 75 ? 'A romantic connection that grows warmer with time.'
    : pct >= 50 ? 'A steady, comfortable relationship in the making.'
    : 'Take it slow and see what unfolds.';

  return (
    <div className="calc-card" style={{ background: 'linear-gradient(180deg, #fecdd3 0%, #ffffff 60%)' }}>
      <div className="flex justify-end px-6 pt-4 [&_button]:!bg-pink-600 [&_button]:!text-white hover:[&_button]:!bg-pink-700"><PrintHeaderButton slug="love"/></div>
      <div className="p-8 pt-2 text-center">
        <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur px-4 py-1.5 rounded-full mb-4">
          <Heart className="w-4 h-4 text-pink-600" /><span className="text-pink-600 font-semibold text-sm">Match Analyzer</span>
        </div>
        <h1 className="text-5xl font-extrabold text-pink-600 mb-3">Love Calculator</h1>
        <p className="text-slate-600 max-w-2xl mx-auto">Discover your love compatibility score based on two names. Higher percentages indicate a stronger romantic connection. This tool is made for fun and entertainment only.</p>

        <div className="mt-8 rounded-3xl p-10 text-white text-center" style={{ background: 'linear-gradient(135deg, #f43f5e, #ec4899)' }}>
          <Heart className="w-10 h-10 mx-auto mb-2 fill-white" />
          <div className="text-7xl font-extrabold">{pct !== null ? pct + '%' : '—'}</div>
          <div className="text-2xl font-bold mt-1">{pct !== null ? message : 'Enter names & calculate'}</div>
          {pct !== null && <div className="mt-4 text-white/90 max-w-xl mx-auto">{line}</div>}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3 items-center">
          <div>
            <div className="text-left text-sm font-semibold text-slate-700 mb-1">Name of Person 1</div>
            <div className="flex items-center gap-2 bg-white rounded-xl px-3 py-3 border border-slate-200">
              <User className="w-4 h-4 text-slate-400" />
              <input value={n1} onChange={e => setN1(e.target.value)} className="flex-1 outline-none" />
            </div>
          </div>
          <button onClick={calc} className="h-14 rounded-2xl text-white font-bold flex items-center justify-center gap-2" style={{ background: 'linear-gradient(135deg, #10b981, #059669)' }}>
            Calculate <Play className="w-4 h-4 fill-white" />
          </button>
          <div>
            <div className="text-left text-sm font-semibold text-slate-700 mb-1">Name of Person 2</div>
            <div className="flex items-center gap-2 bg-white rounded-xl px-3 py-3 border border-slate-200">
              <Heart className="w-4 h-4 text-pink-500" />
              <input value={n2} onChange={e => setN2(e.target.value)} className="flex-1 outline-none" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
